

    import { defineComponent, ref, reactive, computed, PropType, inject, Ref } from 'vue';
    import LocationEntryTSVM from '@Types/search/LocationEntryTSVM';
    import { FilterSelectionLocation, FilterSelectionLocationEntry } from '@Types/FilterSelections';
    import RegionComponent from './RegionComponent.vue';

    export default defineComponent({

        components: { RegionComponent },
        props: {

            country: {
                type: Object as PropType<LocationEntryTSVM>,
                required: true
            },

            isToggled: {
                type: Boolean,
                required: false
            },
        },

        emit: ['toggle', 'select', 'selectRegion'],

        setup(props, context) {


            const filterSelectionLocation = inject("filterSelectionLocation") as Ref<FilterSelectionLocation>;

            const isSelected = computed(() => {


                if (filterSelectionLocation.value.hasValue()) {

                    // should only have country value id
                    if (!filterSelectionLocation.value.selection[0].cityValueId && !filterSelectionLocation.value.selection[0].regionValueId) {
                      
                        return filterSelectionLocation.value.selection[0].countryValueId === props.country.id;
                    }

                }

                return false;
            });

            const onSelect = () => {

             
                context.emit('select', props.country);
            }
            const onSelectRegion = (region: LocationEntryTSVM) => {

                context.emit('selectRegion', props.country, region);
            }
            const onToggle = () => {

                context.emit('toggle', props.country.id);
            }

            return {

                isSelected,
                onSelect,
                onSelectRegion,
                onToggle,
                country: props.country,
                regions: props.country.subEntries

            }

        }



    });


